export const publicTableauInfo = {
  'server': 'https://prod-useast-a.online.tableau.com',
  'site': 'raml'
}